import { MultiSuggestRouteItem } from '@lp/features/MultiSuggest';
import { RouteSegment } from './RouteSegment';
import { ProviderInfo } from './ProviderInfo';

type RouteItemProps = {
  route: MultiSuggestRouteItem;
};

export const RouteItem = ({ route }: RouteItemProps) => {
  return (
    <div className="flex flex-col gap-3">
      <ProviderInfo
        providerType={route.providerType}
        title={route.title}
        routeDurationInMs={route.routeDurationInMs}
        blockTimeRouteDurationInMs={route.blockTimeRouteDurationInMs}
      />
      <div className="flex flex-col gap-2">
        {route.segments.map(({ segmentType, legs }) => (
          <RouteSegment key={segmentType} segmentType={segmentType} legs={legs} />
        ))}
      </div>
    </div>
  );
};
